import { render, staticRenderFns } from "./finalMessage.vue?vue&type=template&id=5459e2be&"
import script from "./finalMessage.vue?vue&type=script&lang=js&"
export * from "./finalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "finalMessage.vue"
export default component.exports